const fmt = (n) => `$${Math.round(n).toLocaleString()}`;

export function CalculatorResults({ costs, savings, vas, year }) {
    const stats = [
        { label: 'WGH program fee', value: `${fmt(costs.fee)}/mo`, testId: 'calc-fee' },
        { label: vas === 1 ? 'VA wages (1 VA)' : `VA wages (${vas} VAs)`, value: `${fmt(costs.wages)}/mo`, testId: 'calc-wages' },
        { label: 'Total monthly cost', value: `${fmt(costs.total)}/mo`, testId: 'calc-total', highlight: true },
        { label: 'Blended cost per hour', value: `$${costs.blended.toFixed(2)}/hr`, testId: 'calc-blended' },
    ];

    return (
        <div>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                {stats.map((s) => (
                    <div
                        key={s.label}
                        className={`rounded-sm p-5 text-center ${s.highlight ? 'bg-gold-400' : 'bg-white/5 border border-white/10'}`}
                        data-testid={s.testId}
                    >
                        <p className={`text-[10px] font-bold uppercase tracking-wider mb-2 ${s.highlight ? 'text-navy-900' : 'text-gray-400'}`}>{s.label}</p>
                        <p className={`font-montserrat font-black text-lg md:text-xl ${s.highlight ? 'text-navy-900' : 'text-white'}`}>{s.value}</p>
                    </div>
                ))}
            </div>
            {year > 1 && savings > 0 && (
                <p className="text-gold-400 text-sm font-semibold mt-6 text-center" data-testid="calc-savings">
                    You save {fmt(savings)}/month compared to Year 1 pricing - that is {fmt(savings * 12)}/year back in your pocket.
                </p>
            )}
        </div>
    );
}
